import { useEffect, useState } from 'react'

/**
 * The public Discord invite, read once from the backend.
 *
 * The link lives in the backend .env rather than the bundle, so the public
 * sites ask for it at runtime. An empty string means none is configured (or the
 * call failed) — callers leave the button out rather than pointing it nowhere.
 */
export default function useDiscordInvite() {
  const [inviteUrl, setInviteUrl] = useState('')

  useEffect(() => {
    let alive = true
    fetch('/api/join/invite')
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (alive) setInviteUrl(d?.invite_url ?? '') })
      .catch(() => {})
    return () => { alive = false }
  }, [])

  return inviteUrl
}
